import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontRobotoCondensed, theme } from "shared/lib/styles";

export type ContainerProps = {
  $fixed: boolean;
};
export const Container = styled.div<ContainerProps>`
  display: none;

  max-inline-size: 1272px;
  margin-block-start: 20px;
  margin-inline: auto;
  padding-block-end: 20px;
  padding-inline: 32px;

  ${theme.breakpoints.up("tablet")} {
    z-index: 2;

    display: block;

    background: #f7f6ef;

    transform: translate3d(0, 0, 0);
  }

  ${props =>
    props.$fixed &&
    css`
      position: fixed;
      inset-block-end: 0;
      inset-inline: 0;
    `}
`;

export const ContentContainer = styled.div`
  border-block-start: 1px solid #000000;

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding-block: 20px;
  padding-inline: 12px;
`;

export const DownloadContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: space-between;
  align-items: center;
`;

export const DownloadText = styled.div`
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 16px;
`;

export const CopyrightContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding-block-start: 11px;

  opacity: 0.6;
  border-block-start: 1px solid #000000;
`;

export const CopyrightText = styled.div`
  font-size: 12px;
  line-height: 14px;
`;
